import * as Atoms from "../../uiComponents/atoms";
import * as Molecules from "../../uiComponents/molecules";
import * as Organisms from "../../uiComponents/organisms";
import * as Modules from "../../uiModules";

const Components: any = { ...Atoms, ...Molecules, ...Organisms, ...Modules };
export default Components;
